import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

export async function parseGLItems(id) {
  const response = await axios.get(`/Invoices/ParseGLItems?id=${id}`);
  return response;
}

// GET
// /Api/Invoices/Invoices
export async function getGroupedInvoicesData(editInProgress = null, invoiceIds = null) {
  const query = new URLSearchParams();
  if (invoiceIds != null) invoiceIds.forEach((id) => query.append('invoiceIds', id));
  query.append('editInProgress', editInProgress);

  const response = await axios.get(`/Invoices/Invoices?${query.toString()}`);
  return response;
}

// GET
// /Api/Invoices/Invoices
export async function getPendingInvoicesData() {
  const response = await axios.get('/Invoices/Invoices?pending=true');
  return response;
}

// GET
// /Api/Invoices/RequeueInvoiceParse
export async function requeueInvoiceParse(id) {
  const response = await axios.get(`/Invoices/RequeueInvoiceParse?id=${id}`);
  return response;
}

export async function getCompleteInvoicesData({ startDate, endDate }) {
  endDate = new Date(endDate).toISOString().split('T')[0];
  startDate = new Date(startDate).toISOString().split('T')[0];
  const response = await axios.get(`/Invoices/CompletedInvoices?Start=${startDate}&End=${endDate}`);
  return response;
}

export async function getInvoiceStatements() {
  const response = await axios.get('/Invoices/InvoiceStatements');
  return response;
}

// GET
// /Api/Invoices/DownloadInvoiceFile
// //Download Api is used in code bec we need the `${HOST_API_URL}
export async function downloadInvoiceFile(id, mainFile) {
  const response = await axios.get(`/Invoices/DownloadInvoiceFile?id=${id}&mainFile=${mainFile}`, {
    responseType: 'blob',
  });
  return response;
}

// GET
// /Api/Invoices/DownloadInvoicesExcel
export async function downloadInvoicesExcel(pathString, invoices, date, downloadType) {
  const params =
    pathString === 'previous'
      ? { Date: date }
      : {
        Invoices: invoices,
        PathString: pathString,
      };

  const urlPath =
    downloadType === 'gl'
      ? pathString === 'previous'
        ? 'DownloadGLCompletedInvoicesExcel'
        : 'DownloadGLInvoicesExcel'
      : pathString === 'previous'
        ? 'DownloadCompletedInvoicesExcel'
        : 'DownloadInvoicesExcel';

  const response = await axios.post(`/Invoices/${urlPath}`, params, { responseType: 'blob' });
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'Invoices.xlsx';
  a.click();
  window.URL.revokeObjectURL(url);
  return response;
}

// GET
// /Api/Invoices/InvoiceNotes
export async function getInvoiceNotes(id) {
  const response = await axios.get(`/Invoices/InvoiceNotes?id=${id}`);
  return response;
}

//POST
//
export async function markInvoiceAsSent(id) {
  const response = await axios.post(`/Invoices/MarkInvoiceAsSent?id=${id}&sent=true`);
  return response;
}

// POST
// /Api/Invoices/AddInvoiceFile id file
export async function postAddInvoiceFile(id, file) {
  const formData = objectToFormData({
    id,
    file,
  });
  const response = await axios.post('/Invoices/AddInvoiceFile', formData);
  return response;
}

//POST
// /Api/Invoices/DeleteInvoiceFile id
export async function deleteInvoiceFile(id) {
  const response = await axios.post(`/Invoices/DeleteInvoiceFile?id=${id}`);
  return response;
}

// /Api/Invoices/DeleteInvoice id
export async function deleteInvoice(id) {
  const response = await axios.post(`/Invoices/DeleteInvoice?id=${id}`);
  return response;
}

export async function deleteInvoices(ids) {
  const formData = objectToFormData({
    ids,
  });
  const response = await axios.post('/Invoices/DeleteInvoices', formData);
  return response;
}

// POST
// /Api/Invoices/SetInvoiceFileAsMain id
export async function setInvoiceFileAsMain(id) {
  const response = await axios.post(`/Invoices/SetInvoiceFileAsMain?id=${id}`);
  return response;
}

// POST
// /Api/Invoices/RecreateInvoice id
export async function recreateInvoice(id) {
  const response = await axios.post(`/Invoices/RecreateInvoice?id=${id}`);
  return response;
}

// GET
// /Api/Invoices/InvoiceFiles
export async function getInvoiceItemsFiles(id) {
  const response = await axios.get(`/Invoices/InvoiceFiles?id=${id}`);
  return response;
}

// GET
// /Api/Invoices/InvoiceLogFormatted
export async function getInvoiceLogFormatted(invoiceId) {
  const response = await axios.get(`/Invoices/InvoiceLogFormatted?invoiceId=${invoiceId}`);
  return response;
}

export async function GetItemQuantityInvoice(vendorItemId, vendorId, orderNumber) {
  const response = await axios.get(
    `/Invoices/GetItemQuantityInvoice?vendorItemId=${vendorItemId}&vendorId=${vendorId}&orderNumber=${orderNumber}`
  );
  return response;
}

// GET/Api/Invoices/InvoiceFormData;
export async function getInvoiceFormData(isManual) {
  const response = await axios.get(`/Invoices/InvoiceFormData?isManual=${isManual}`);
  return response;
}

// GET/Api/Invoices/EditInvoiceFacilities;
export async function getEditFacilities(isManual) {
  const response = await axios.get(`/Invoices/EditInvoiceFacilities?isManual=${isManual}`);
  return response;
}

// GET
// /Api/Invoices/InvoiceGlItems invoiceId
export async function getInvoiceGlItems(invoiceId) {
  const response = await axios.get(`/Invoices/InvoiceGlItems?invoiceId=${invoiceId}`);
  return response;
}

// GET
// /Api/Invoices/Invoice id
export async function getSingleInvoice(id) {
  const response = await axios.get(`/Invoices/Invoice?id=${id}`);
  return response;
}

// POST/Api/Invoices/UpdateInvoiceItems; invoiceId items
//objectToFormData
export async function updateInvoiceItems(invoiceId, data) {
  const items = data?.map((item) => {
    const {
      id,
      description,
      uomType,
      vendorItemId,
      expectedItemPrice,
      price,
      quantity,
      taxAmount,
      expectedAmount,
      categoryId,
      subcategoryId,
      glCode,
      deleteFlag,
      manual,
    } = item;
    return {
      id,
      description,
      uomType,
      vendorItemId,
      expectedItemPrice,
      price,
      quantity,
      taxAmount,
      agoraCategoryId: categoryId,
      agoraSubcategoryId: subcategoryId,
      glCode,
      expectedAmount,
      deleteFlag,
      manual,
    };
  });

  const formData = objectToFormData({
    InvoiceId: invoiceId,
    Items: items,
  });
  const response = await axios.post('/Invoices/UpdateInvoiceItems', formData);
  return response;
}

// POST/Api/Invoices/BookInvoice; InvoiceAttachId BillNumber DueDate TransactionDate GlPostingDate Lines [{"transactionAmount": 0,"glCode": "string","memo": "string"}]
export async function bookInvoice(invoice, forceThroughDisabledAccount, duplicateTypes) {
  const payload = [
    {
      invoiceId: invoice?.id,
      forceThroughDisabledAccount,
      duplicateTypes: duplicateTypes ?? [],
    },
  ];
  const response = await axios.post('/Invoices/BookInvoices', payload);
  return response;
}
// POST/Api/Invoices/RemoveInvoiceFromQue;
export async function removeInvoiceFromQue(id) {
  const formData = objectToFormData({
    id,
  });
  const response = await axios.post('/Invoices/RemoveInvoiceFromQue', formData);
  return response;
}

// POST/Api/Invoices/BulkBookInvoices;
export async function bulkBookInvoices(invoicesIds) {
  const payload = invoicesIds.map((invoiceId) => ({
    invoiceId,
    forceThroughDisabledAccount: false,
    duplicateTypes: [],
  }));
  const response = await axios.post('/Invoices/BookInvoices', payload);
  return response;
}

// POST/Api/Invoices/DeleteInvoiceStatement;
export async function deleteInvoiceStatement(id) {
  const response = await axios.post(`/Invoices/DeleteInvoiceStatement?id=${id}`);
  return response;
}

// POST/Api/Invoices/SplitPdf; splitOn[2,4] excludedPages[3] file
export async function splitPdf(splitOn, excludedPages, file, invoiceId) {
  const formData = objectToFormData({
    splitOn,
    excludedPages,
    file,
    invoiceId,
  });
  const response = await axios.post('/Invoices/SplitPdf', formData, {
    responseType: 'blob',
  });
  return response;
}

// GET/Api/Invoices/ParsingInvoices;
export async function getParsingInvoices() {
  const response = await axios.get('/Invoices/ParsingInvoices');
  return response;
}

// GET/Api/Invoices/InvoiceProcessingQueue;
export async function getInvoiceProcessingQueue(invoiceId) {
  const response = await axios.get(`/Invoices/InvoiceProcessingQueue?invoiceId=${invoiceId}`);
  return response;
}

// GET/Api/Invoices/stopParsingInvoice;
export async function stopParsingInvoice(id) {
  const response = await axios.get(`/Invoices/StopParsingInvoice?id=${id}`);
  return response;
}

// GET/Api/Invoices/GetInvoiceOCRStatus;
export async function getInvoiceOCRStatus(id) {
  const response = await axios.get(`/Invoices/GetInvoiceOCRStatus?id=${id}`);
  return response;
}

// POST/Api/Invoices/ManualInvoiceUpload; files
export async function uploadManualInvoices(files) {
  const formData = objectToFormData({
    files,
  });
  const response = await axios.post('/Invoices/ManualInvoiceUpload', formData);
  return response;
}

// POST/Api/Invoices/UploadInvoicePdf; vendorId file
export async function uploadInvoicePdf(vendorId, file) {
  const formData = objectToFormData({
    vendorId,
    file,
  });
  const response = await axios.post('/Invoices/UploadInvoicePdf', formData);
  return response;
}

// POST/Api/Invoices/UploadStatement;
export async function uploadStatement(vendorId, file) {
  const formData = objectToFormData({
    vendorId,
    file,
  });
  const response = await axios.post('/Invoices/UploadStatement', formData);
  return response;
}

// POST/Api/Invoices/GenerateInvoicePdfFromData; id
export async function generateInvoicePdfFromData(id) {
  const response = await axios.post(`/Invoices/GenerateInvoicePdfFromData?id=${id}`);
  return response;
}

// GET/Api/Invoices/InvoiceStatementLines; id
export async function getInvoiceStatementLines(id) {
  const response = await axios.get(`/Invoices/InvoiceStatementLines?id=${id}`);
  return response;
}

// GET
// /Api/Invoices/InvoiceGLs
export async function getInvoiceGLsData() {
  const response = await axios.get('/Invoices/InvoiceGLs');
  return response;
}

// POST
// /Api/Invoices/VendorForm
export async function postGLForm(form) {
  const updatedForm = {
    id: form.id,
    FacilityId: form.facility?.value,
    GLCode: form.glCode,
    CategoryId: form.categoryId,
    CategoryCode: form.category,
    CategoryDescription: form.categoryDesc,
    Description: form.subcategory,
  };

  const formData = objectToFormData({
    ...updatedForm,
  });

  if (form.deleteCats?.length > -1) {
    for (let index = 0; index < form.deleteCats.length; ++index) {
      formData.append(`DeleteCategories[${index}]`, form.deleteCats[index]?.categoryId);
    }
  }

  const response = await axios.post('Invoices/GLForm', formData);
  return response;
}

// POST
// /Api/Invoices/DepartmentForm
export async function postGLDeptForm(form) {
  const updatedForm = {
    FacilityId: form.facility?.value,
    CategoryId: form.categoryId ?? form.id,
    Id: form.categoryId ?? form.id,
    CategoryCode: form.category,
    CategoryDescription: form.categoryDesc,
  };

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Invoices/DepartmentForm', formData);
  return response;
}

// GET
// /Api/Invoices/APIGLs
export async function getGLAPIData(facilityId, mode) {
  const response = await axios.get(`/Invoices/APIGLs?facilityId=${facilityId}&mode=${mode}`);
  return response;
}

// GET
// /Api/Invoices/RefreshAPIGLs
export async function refreshGLAPIData(facilityId, mode) {
  const response = await axios.get(`/Invoices/RefreshAPIGLs?facilityId=${facilityId}&mode=${mode}`);
  return response;
}

// POST
// /Api/Invoices/APIGLForm
export async function postAPIGLForm(form, glIds) {
  const updatedForm = {
    FacilityId: form.facility?.value,
    Mode: form.mode,
  };
  const formData = objectToFormData({
    ...updatedForm,
  });
  if (glIds?.length) {
    for (let index = 0; index < glIds.length; ++index) {
      formData.append(`VendorIds[${index}]`, glIds[index]);
    }
  }
  const response = await axios.post('Invoices/APIGLForm', formData);
  return response;
}

// POST
//APi/Invoices/DeleteGL glId
export async function postDeleteGL(glId) {
  const response = await axios.post(`/Invoices/DeleteGL?id=${glId}`);
  return response;
}

// POST
//APi/Invoices/postDeleteGLCategory id
export async function postDeleteGLCategory(id) {
  const response = await axios.post(`/Invoices/DeleteGLCategory?id=${id}`);
  return response;
}

// GET/Api/Invoices/DownloadInvoiceStatementFile;
// //Download Api is used in code bec we need the `${HOST_API_URL}

// GET/Api/Invoices/ViewStatementFile;
// //View Api is used in code bec we need the `${HOST_API_URL}

// GET/Api/Invoices/ViewInvoiceFile;
// //View Api is used in code bec we need the `${HOST_API_URL}
export async function viewInvoiceFile(id, mainFile) {
  const response = await axios.get(`/Invoices/ViewInvoiceFile?id=${id}&mainFile=${mainFile}`, {
    responseType: 'blob',
  });
  return response;
}

// POST/Api/Invoices/InvoiceForm
export async function postInvoiceForm(invoice) {
  const updatedData = {
    Id: invoice.id,
    VendorId: invoice.vendorId,
    FacilityId: invoice.facilityId,
    InvoiceId: invoice.invoiceId,
    VendorInvoiceId: invoice.vendorInvoiceId,
    ExpectedPrice: invoice.expectedPrice,
    Shipping: invoice.shipping,
    Quantity: invoice.quantity,
    Total: invoice.total,
    InvoiceType: invoice.invoiceType,
    MultiFacility: invoice.multiFacility,
    ReferenceNumber: invoice.referenceNumber,
    AlreadySent: invoice.sent,
    Date: invoice.date,
    DueDate: invoice.dueDate,
    GlPostingDate: invoice.glPostingDate,
    SourceMethod: invoice.sourceMethod,
  };

  const formData = objectToFormData(updatedData);
  const response = await axios.post('/Invoices/InvoiceForm', formData);
  return response;
}
// POST/Api/Invoices/UpdateInvoiceField
export async function updateInvoiceField(invoiceId, field) {
  const formData = new FormData();
  formData.append('id', invoiceId);
  formData.append('key', field.key);
  formData.append('value', field.value);

  const response = await axios.post('/Invoices/UpdateInvoiceField', formData);
  return response;
}

// POST/Api/Invoices/InvoiceGLItemsForm
export async function postInvoiceGLItemsForm(invoiceGlItems, addedBy = "") {
  const formData = new FormData();
  invoiceGlItems.forEach((item, index) => {
    Object.entries(item).forEach(([key, value]) => {
      formData.append(`${'input'}[${index}].${key}`, value !== null && value !== '' ? value : '');
    });
  });
  formData.append('addedBy', addedBy );
  const response = await axios.post('/Invoices/InvoiceGLItemsForm', formData);
  return response;
}

// POST/Api/Invoices/RemoveGlItems
export async function removeGlItems(invoiceId) {
  const response = await axios.post(`/Invoices/RemoveGlItems?invoiceId=${invoiceId}`);
  return response;
}
// POST/Api/Invoices/FacilityModeToggle
export async function facilityModeToggle(invoiceId, mode) {
  const formData = objectToFormData({
    InvoiceId: invoiceId,
    Mode: mode,
  });
  const response = await axios.post('/Invoices/FacilityModeToggle', formData);
  return response;
}
export async function getInvoiceStatus(id) {
  const response = await axios.post(`/Invoices/InvoiceStatus?id=${id}`);
  return response;
}

// POST/APi/Invoices/AddInvoiceLogMessage
export async function addInvoiceLogMessage(
  invoiceId,
  messageType,
  extraInfo,
  mentions = null,
  parentCommentId,
  files,
  invoiceUrl
) {
  const formData = objectToFormData({
    invoiceId,
    messageType,
    extraInfo,
    mentions,
    parentCommentId,
    invoiceUrl,
  });
  files?.forEach((file) => {
    formData.append('files', file);
  });
  const response = await axios.post('/Invoices/AddInvoiceLogMessage', formData);
  return response;
}

// POST
//APi/Invoices/DeleteInvoiceLogMessage
export async function deleteInvoiceLogMessage(logId) {
  const response = await axios.post(`/Invoices/DeleteInvoiceLogMessage?logId=${logId}`);
  return response;
}

// GET
// /Api/Invoices/InvoiceLog
export async function getInvoiceLogData(invoiceId) {
  const response = await axios.get(`/Invoices/InvoiceLog?invoiceId=${invoiceId}`);
  return response;
}
// GET
// /Api/Invoices/InvoiceBreakdownData
export async function getInvoiceBreakdownData(id, mode = 'Full') {
  const response = await axios.get(`/Invoices/InvoiceBreakdownData?id=${id}&mode?=${mode}`);
  return response;
}
// GET
// /Api/Invoices/InvoiceAnalyzeLogs
export async function getInvoiceAnalyzeLogs(id) {
  const response = await axios.get(`/Invoices/InvoiceAnalyzeLogs?id=${id}`);
  return response;
}
// GET
// /Api/Invoices/DuplicateInvoice
export async function getDuplicateInvoices(input) {
  const response = await axios.get(`/Invoices/DuplicateInvoices`, { params: input });
  return response;
}
// GET
// /Api/Invoices/RelatedInvoices
export async function getRelatedInvoices(id) {
  const response = await axios.get(`/Invoices/RelatedInvoices?id=${id}`);
  return response;
}
// GET
// /Api/Invoices/InvoiceViewers
export async function getInvoiceViewersList(invoiceId) {
  const response = await axios.get(`/Invoices/InvoiceViewers?invoiceId=${invoiceId}`);
  return response;
}
// GET
// /Api/Invoices/InvoiceViewersPerFacility
  export async function getInvoiceViewersPerFacility(facilityId, sourceMethod) {
    const response = await axios.get(`/Invoices/InvoiceViewersPerFacility?facilityId=${facilityId}&sourceMethod=${sourceMethod}`);
  return response;
}

// GET
// /Api/Invoices/FacilityApprovalAssignments
export async function getFacilityApprovalAssignments(isManual) {
  const response = await axios.get(`/Invoices/FacilityApprovalAssignments?isManual=${isManual}`);
  return response;
}

// GET
// /Api/Invoices/InvoiceViewers
export async function getInvoiceApproverOptions(isManual) {
  const response = await axios.get(`/Invoices/GetInvoiceApproverOptions?isManual=${isManual}`);
  return response;
}

// GET
// /Api/Invoices/InvoiceApprovers
export async function getInvoiceApprovers(invoiceId) {
  const response = await axios.get(`/Invoices/InvoiceApprovers?id=${invoiceId}`);
  return response;
}

// POST
// /Api/Invoices/AssignInvoiceApprovers
export async function postInvoiceApprovers(invoiceId, approvers) {
  const formData = objectToFormData({
    invoiceId,
    Approvers: approvers.map((item) => ({
      approvalIndex: item.approvalIndex,
      name: item.approverFullName,
      value: item.approverEmail,
      status: item.status,
    })),
  });
  const response = await axios.post(`/Invoices/AssignInvoiceApprovers`, formData);
  return response;
}

// POST
// /Api/Invoices/AssignFacilityInvoiceApprovers
export async function postFacilityInvoiceApprovers(facilityIds, vendorIds, approvers, isManual) {
  const formData = objectToFormData({
    facilityIds,
    vendorIds: vendorIds.length === 0 ? [0] : vendorIds,
    Approvers: approvers.map((item, index) => ({
      approvalIndex: index,
      value: item.id,
      name: item.value
    })),
    isManual,
  });
  const response = await axios.post(`/Invoices/AssignFacilityInvoiceApprovers`, formData);
  return response;
}

// POST
// /Api/Invoices/DeleteFacilityInvoiceApprovers
export async function postDeleteFacilityInvoiceApprovers(facilityIds, vendorIds, approvers, isManual) {
  const formData = objectToFormData({
    facilityIds,
    vendorIds: vendorIds.length === 0 ? [0] : vendorIds,
    Approvers: approvers.map((item) => ({
      value: item.id,
    })),
    isManual,
  });
  const response = await axios.post(`/Invoices/DeleteFacilityInvoiceApprovers`, formData);
  return response;
}

// POST
//APi/Invoices/RequestReview
export async function requestReview(invoiceId) {
  const response = await axios.post(`/Invoices/RequestReview?id=${invoiceId}`);
  return response;
}
// POST
//APi/Invoices/ApproveInvoice
export async function processInvoiceApproval(invoiceId, approvalStatus, comment) {
  const response = await axios.post(
    `/Invoices/ApproveInvoice?id=${invoiceId}&approvalStatus=${approvalStatus}&comment=${comment}`
  );
  return response;
}

// GET
// /Api/Invoices/InvoiceFacilitySettings
export async function getFacilityInvoiceSettingsAPI() {
  const response = await axios.get(`/Invoices/InvoiceFacilitySettings`);
  return response;
}

// GET
// /Api/Invoices/FacilityManagers
export async function getFacilityManagersApi() {
  const response = await axios.get(`/Invoices/GetFacilityManagers`);
  return response;
}

// POST
// /Api/Invoices/UpdateFacilitiesGlConsolidation
export async function updateFacilitiesGlConsolidation(facilities, isManual = false) {
  const formData = objectToFormData({
    Facilities: facilities,
    IsManual: isManual,
  });
  const response = await axios.post(`/Invoices/UpdateFacilitiesGlConsolidation`, formData);
  return response;
}

// POST
// /Api/Invoices/UpdateFacilityInvoiceVendorLineItem
export async function updateFacilityInvoiceVendorLineItem(facilities) {
  const response = await axios.post(`/Invoices/UpdateFacilityInvoiceVendorLineItem`, objectToFormData({ facilities }));
  return response;
}

// POST
// /Api/Invoices/FindAndReplace
export async function findAndReplace(value, invoiceIds) {
  const formData = objectToFormData({
    replaceType: value?.replaceType,
    FindId: value.find?.id,
    ReplaceId: value.replaceWith?.id,
  });

  if (invoiceIds?.length) {
    for (let index = 0; index < invoiceIds.length; ++index) {
      formData.append(`InvoiceIds[${index}]`, invoiceIds[index]);
    }
  }

  const response = await axios.post(`/Invoices/FindAndReplace`, formData);
  return response;
}

// POST
// /Api/Invoices/InvoicesAdvancedOrderSearch
export async function invoicesAdvancedOrderSearch(input) {
  const formData = objectToFormData(input);
  const response = await axios.post(`/Invoices/InvoicesAdvancedOrderSearch`, formData);
  return response;
}

// GET
// /Api/Invoices/InvoiceChatContacts
export async function getInvoiceChatContacts(invoiceId) {
  const response = await axios.get(`/Invoices/InvoiceChatContacts?invoiceId=${invoiceId}`);
  return response;
}

// GET
// /Api/Invoices/GetInvoiceChatUsers
export async function getInvoiceChatUsers(invoiceId) {
  const response = await axios.get(`/Invoices/GetInvoiceChatUsers?invoiceId=${invoiceId}`);
  return response;
}

// POST
// /Api/Invoices/AddInvoiceChatUser
export async function addInvoiceChatUser(invoiceId, userId, invoiceUrl, userEmail) {
  const formData = new FormData();
  formData.append('invoiceId', invoiceId);
  formData.append('invoiceUrl', invoiceUrl);
  if (userId) formData.append('userId', userId);
  if (userEmail) formData.append('userEmail', userEmail);
  const response = await axios.post('/Invoices/AddInvoiceChatUser', formData);
  return response;
}

// POST
// /Api/Invoices/DeleteInvoiceChatUser
export async function deleteInvoiceChatUser(invoiceId, userId, userEmail) {
  const formData = new FormData();
  formData.append('invoiceId', invoiceId);
  if (userId) formData.append('userId', userId);
  if (userEmail) formData.append('userEmail', userEmail);
  const response = await axios.post(`/Invoices/DeleteInvoiceChatUser`, formData);
  return response;
}

// POST
// /Api/Invoices/SetEmailChatUpdates
export async function setEmailChatUpdates(invoiceId, sendUpdates) {
  const response = await axios.post(`/Invoices/SetEmailChatUpdates?invoiceId=${invoiceId}&sendUpdates=${sendUpdates}`);
  return response;
}

// GET
// /Api/Invoices/ProcessFailedInvoices
export async function processFailedInvoices() {
  const response = await axios.get('/Invoices/ProcessFailedInvoices');
  return response;
}

// GET
// /Api/Invoices/BookingTypeSubmitSchedules
export async function getBookingTypeSubmitSchedules() {
  const response = await axios.get('/Invoices/BookingTypeSubmitSchedules');
  return response;
}
